<template>
  <div class="orgBox">
    <!-- 搜索栏 -->
    <el-input
      ref="searchKey"
      class="searchKey"
      placeholder="搜索"
      prefix-icon="el-icon-search"
      v-model="searchKeyWord"
    ></el-input>
    <!-- 正常加载的数据 -->
    <orgBox2 v-show="!showSearchList" v-bind="orgBox2Props" ref="orgBox"></orgBox2>
    <!-- 搜索的数据 -->
    <orgBox2 v-if="showSearchList" v-bind="orgBox2Props" :is-search="true"></orgBox2>
  </div>
</template>

<script>
import orgBox2 from "./orgBox2.vue";
export default {
  name: "orgBox",
  props: {
    isRole: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchKeyWord: null,
      showSearchList: false,
    };
  },
  components: {
    orgBox2,
  },
  provide() {
    return {
      $orgBoxSearch: this,
    };
  },
  computed: {
    orgBox2Props() {
      return {
        isRole: this.isRole,
        searchKeyword: this.searchKeyWord,
        style: {
          height: `calc(100% - 80px)`,
        },
      };
    },
  },
  watch: {
    searchKeyWord(n, o) {
      if (n !== o) {
        this.showSearchList = false;
        this.changeShowSearchList();
      }
    },
  },
  created() {
    this.changeShowSearchList = _.debounce(() => {
      this.showSearchList = this.searchKeyWord && this.searchKeyWord != "";
    }, 300);
  },
};
</script>
